export const capitalize = (nomeCompleto: string): string => {
  const nomes = nomeCompleto.toLowerCase().split(' ');
  return nomes.map(nome => {
    if (nome === 'de') return nome;
    if (nome === 'e') return nome;
    return nome[0].toUpperCase() + nome.substring(1);
  }).join(' ');
};